/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteGrant.defs.js";
export { main as default } from "./deleteGrant.defs.js";
